import { Container } from "@mui/material";
import React from "react";

const RightBar = () => {
  return <Container className="pt-28 h-screen sticky top-0"></Container>;
};

export default RightBar;
